import React from 'react';

// 商品数量组件
const ProductNum = ({ items, productId, cls }) => {
    if (!items) return null;
    const item = items?.filter(item => item.productId === productId);
    const quantity = item?.reduce((sum, item) => sum + (item.quantity || 0), 0);
    return quantity ? <div className={`product-num ${cls}`}>{quantity}</div> : null;
};

export default ProductNum; 